<template>
    <div name="search" class="search" v-if="result === 0">
        <img class="image" src="../../assets/showcase/xi/search/1.png" />
        <img class="image" src="../../assets/showcase/xi/search/2.png" @click="goResult" />
        <img class="image" src="../../assets/showcase/xi/search/3.png" />
        <img v-if="tab === 0" class="image" src="../../assets/showcase/xi/search/4_1.png" @click="tabClick" />
        <img v-else class="image" src="../../assets/showcase/xi/search/4_2.png" @click="tabClick"/>
        <img v-if="tab === 0" class="image" src="../../assets/showcase/xi/search/5_1.png" />
        <img v-else class="image" src="../../assets/showcase/xi/search/5_2.png" />
    </div>
    <div v-else class="search" >
        <img class="image" src="../../assets/showcase/xi/search/map_1.png" @click="result = 0" />
        <img class="image" src="../../assets/showcase/xi/search/map_2.png" />
        <div style="margin-bottom: calc(100vw * 60 / 375);  bottom: calc(100vw * 57 / 375); position: fixed; width: calc(100% - 12.4px - 7vw); display: flex;flex-direction: column; left: 4vw">
            <img class="image" src="../../assets/showcase/xi/search/map_3.png"  />
            <img class="image" src="../../assets/showcase/xi/search/map_4.png" @click="goBooking"/>
        </div>

    </div>
</template>

<script>
export default {
    name: 'search',
    data: function()
    {
        return {
            tab: 0,
            result: 0
        }
    },
    methods: {
        tabClick: function()
        {
            this.tab = this.tab === 0 ? 1 : 0;
        },
        goResult: function()
        {
            this.result = 1;   
        },
        goBooking: function()
        {
            this.$emit('goBookingTab')
        }
    }
}
</script>

<style scoped>
    .search {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        background: #FFF;
    }
    .image {
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/Search.vue